import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Post from "../../../Apis/backlink/Post";
import { auth2 } from "../../../firebase";
import { getAPIUrlBM } from "../../../utils/config";
import "./style.css";

function CouponCode() {
  const navigate = useNavigate();
  const [couponCode, setCouponCode] = useState();
  const sweet = window.sweet;
  const [errorMsg, setErrorMsg] = useState("");
  const handleChange = (e) => {
    setCouponCode(e.target.value);
  };
  const [plan, setPlan] = useState();

  const handleSubmit = async () => {
    try {
      if (plan === "plan26") {
        sweet({
          title: "Info!",
          text: "You already have top Plan!!",
          icon: "info",
        });
        return;
      }
  
      const url = getAPIUrlBM();
      const response = await Post(url + "/redeemcode", {
        redeemcode: couponCode,
      });
      if (response.status !== 200) {
        setErrorMsg(response.message);
        setTimeout(() => {
          setErrorMsg("");
        }, 3000);
      } else {
        setErrorMsg("");
        if (response.message === "Code Redeem successfully") {
          sweet({
            title: "Success!",
            text: `Congo!! Refresh page to enjoy new Plan.`,
            icon: "success",
          });
          await auth2.currentUser.reload();
        } else
          sweet({
            title: "Info!",
            text: "You already have top Plan!!",
            icon: "info",
          });
        navigate("/backlink");
      }
      
    } catch (error) {
      console.log(error)
    }
    // console.log(response);
  };

  useEffect(() => {
    const get = async () => {
      try {
        const paid = JSON.parse(
          auth2.currentUser.reloadUserInfo?.customAttributes,
        );
        console.log(paid, "COMING");
        setPlan(paid?.plan);
      
      } catch (error) {
        console.log(error)
      }
    };
    get();
  }, []);

  return (
    <div className="couponContainer">
      <div className="couponDiv">
        <p className="title">Enter the CouponCode</p>
        <input type="text" value={couponCode} onChange={handleChange} />
        {errorMsg.length != 0 && <p className="errorMsg">{errorMsg}</p>}
        <button className="submitButton" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}

export default CouponCode;
